<div class="boq-table-wrap">
  <div class="boq-table-head">
    <h2>Quantities</h2>
    <span class="boq-item-count">{{ wb.previewItems.length }} items</span>
    <div class="boq-head-actions">
      <button
        type="button"
        class="boq-head-btn"
        *ngIf="tableExpanded"
        (click)="toggleTiles()"
      >
        {{ tilesHidden ? 'Show totals' : 'Hide totals' }}
      </button>
      <button
        type="button"
        class="boq-head-btn"
        (click)="toggleExpanded()"
        [attr.aria-expanded]="tableExpanded"
      >
        {{ tableExpanded ? 'Less table' : 'More table' }}
      </button>
    </div>
  </div>

  <ng-container *ngIf="tableExpanded">
  <div class="boq-tiles" *ngIf="!tilesHidden">
    <div class="tile" *ngFor="let tile of tiles()">
      <span class="tile-label">{{ tile.label }}</span>
      <span class="tile-value">₹ {{ tile.value | number: '1.0-0' }}</span>
    </div>
    <div class="tile tile-grand">
      <span class="tile-label">Grand</span>
      <span class="tile-value">₹ {{ wb.totals.grand | number: '1.0-0' }}</span>
    </div>
  </div>

  <div class="boq-table-scroll">
    <table class="boq-lines">
      <thead>
        <tr>
          <th>Item</th>
          <th>Layer</th>
          <th>Length</th>
          <th>Width</th>
          <th>Thickness</th>
          <th>Volume</th>
          <th>Unit</th>
          <th>Rate (₹)</th>
          <th>Cost (₹)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!wb.previewItems.length">
          <td colspan="9" class="empty">
            {{ wb.loading ? 'Calculating quantities…' : 'Set chainage and recalculate to preview BoQ lines.' }}
          </td>
        </tr>
        <tr *ngFor="let row of wb.previewItems; trackBy: trackRow" [class.row-edited]="isEdited(row)">
          <td>
            {{ row.item_description }}
            <span class="morth-ref" *ngIf="row.morth_ref">{{ row.morth_ref }}</span>
          </td>
          <td>{{ row.layer || '—' }}</td>
          <td>{{ row.length_m != null ? (row.length_m | number: '1.0-1') : '—' }}</td>
          <td>{{ row.width_m != null ? (row.width_m | number: '1.1-2') : '—' }}</td>
          <td>{{ row.thickness_m != null ? (row.thickness_m | number: '1.2-2') : '—' }}</td>
          <td>{{ (row.volume != null ? row.volume : row.quantity) | number: '1.1-2' }}</td>
          <td>{{ row.unit }}</td>
          <td>
            <input
              class="boq-edit"
              type="number"
              min="0"
              step="1"
              [value]="row.unit_rate"
              (change)="onRateChange(row, $any($event.target).value)"
              [attr.aria-label]="'Rate for ' + row.item_description"
            />
          </td>
          <td>
            <input
              class="boq-edit boq-edit-cost"
              type="number"
              min="0"
              step="1"
              [value]="row.cost"
              (change)="onCostChange(row, $any($event.target).value)"
              [attr.aria-label]="'Cost for ' + row.item_description"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </ng-container>

  <div class="boq-actions">
    <span class="status" *ngIf="wb.status">{{ wb.status }}</span>
    <button type="button" class="btn-open" (click)="wb.saveRates()" [disabled]="wb.savingRates || !wb.previewItems.length">
      {{ wb.savingRates ? 'Saving rates…' : 'Save rates' }}
    </button>
    <button type="button" class="btn-apply" (click)="wb.apply()" [disabled]="wb.applying || !wb.previewItems.length">
      {{ wb.applying ? 'Saving…' : (wb.appliedRoadBoqId ? 'Update Road BoQ' : 'Apply') }}
    </button>
    <button type="button" class="btn-open" (click)="wb.openRoadBoq()">Open Road BoQ</button>
  </div>
</div>
